import Fitness from '../assets/previews/fitness.png';
import Sword from '../assets/previews/sword.jpg';
import Blog from '../assets/previews/blog.png';
import Commerce from '../assets/previews/commerce.png';
import Tracker from '../assets/previews/tracker.jpg';
import Notes from '../assets/previews/notes.png';
import Team from '../assets/previews/notes.png';
import Readme from '../assets/previews/readme.png';
import Sits from '../assets/previews/sits.png';
import Weather from '../assets/previews/weather.png';
import Planner from '../assets/previews/planner.png';
import Quiz from '../assets/previews/quiz.png';
import Password from '../assets/previews/password.png';
import Snippet from '../assets/previews/snippet.png';

const Data = [
	{
		id: 14,
		project_name: 'Workout Tracker',
		live_link: 'https://wk18-workout-tracker.herokuapp.com',
		repo_link: 'https://github.com/BrigittePowers/wk18-workout-tracker',
		skill: 'NPM | Express | Mongo Database | Atlas | Heroku | Mongoose | Back-End',
		description:
			'A fitness progress app that allows a user to create, edit, or continue a workout and fill it with a variety of exercises. The application also allows the user to view a statistics dashboard that charts their workout duration and resistance goals.',
		date: 'NOV 2021',
		image: Fitness,
	},
	{
		id: 13,
		project_name: 'The Sword',
		live_link: 'https://endless-ocean-34575.herokuapp.com',
		repo_link: 'https://github.com/BrigittePowers/proj2-text-adventure',
		skill: 'MCV | Handlebars | Sessions | Authentication || Express | Node | Models | User-Responsive Data',
		description:
			'Are you brave enough to venture forth and claim your prize? Play this interactive walking adventure made with MYSQL and Express.js. The Sword is an interactive adventure game / walking sim designed to showcase authentication, protection of sensitive information, server routes, database management, and responsive design.',
		date: 'NOV 2021',
		image: Sword,
	},
	{
		id: 12,
		project_name: 'Tech Blog',
		live_link: 'https://bpowers-wk14-tech-blog.herokuapp.com',
		repo_link: 'https://github.com/BrigittePowers/wk14-tech-blog',
		skill: 'MVC | Handlebars | Cookies | Sessions | Authentication | Express | Node',
		description:
			'This project is a tech blog that allows account creation then the user can create posts or comments to be viewed by others. User-data can be edited, deleted, or updated as requested. All information is stored to a MySQL database.',
		date: 'NOV 2021',
		image: Blog,
	},
	{
		id: 11,
		project_name: 'E-Commerce Back End',
		live_link: '',
		repo_link: 'https://github.com/BrigittePowers/wk13-ecommerce-back-end',
		skill: 'Node | Express |  MySQL | Databse | Sequelize | Models | Validation | Authentication | Hooks',
		description:
			'The goal of the project is to create a back-end in order to connect a MYSQL database to an e-commerce website utilizing dotenv for security, sequelize for database management, and mysql servers.[note: video demonstration available on github]',
		date: 'OCT 2021',
		image: Commerce,
	},
	{
		id: 10,
		project_name: 'Town Portal Employee Tracker',
		live_link: '',
		repo_link: 'https://github.com/BrigittePowers/wk12-employee-tracker',
		skill: 'MySQL | Database | Inquirer | Node | Seeding | Express',
		description:
			'TownPortal is a program through node that allows communication to a MySQL database. TP allows the creation of departments and job positions within those departments; it then allows one to add employee information and lookup database-stored info whenever needed. The ultimate goal of TownPortal is to allow one to keep track of their company employee data in a way that is succinct, comprehensible, and efficient. Ideally, it is a program that allows an employer to manage their company with reduced setbacks. [note: video demonstration available on github]',
		date: 'OCT 2021',
		image: Tracker,
	},
	{
		id: 9,
		project_name: 'Note Taker',
		live_link: 'https://bp-express-note-taker.herokuapp.com/',
		repo_link: 'https://github.com/BrigittePowers/wk11-note-taker',
		skill: 'Node | Express | UUID | Routes | Middleware | Query Parameters',
		description:
			'The goal was to allow a system for taking notes that would sync to a server application hosted by Heroku so that the app is accessible anywhere. User can read, write, modify, and delete notes that are then stored in a saved database for access.',
		date: 'OCT 2021',
		image: Notes,
	},
	{
		id: 8,
		project_name: 'Team Profile Generator',
		live_link: '',
		repo_link:
			'https://github.com/BrigittePowers/wk10-team-profile-generator',
		skill: 'Node | Inquirer | Object-Oriented | Tests | Constructors | Promises | Classes',
		description:
			'The goal of the project is to create a way for users to organize their employees by reporting manager. This project generates an html file utilizing the user`s input and applies css styling to the newly-made webpage for easy viewing. [note: video demonstration available on github]',
		date: 'OCT 2021',
		image: Team,
	},
	{
		id: 7,
		project_name: 'README Generator',
		live_link: '',
		repo_link: 'https://github.com/BrigittePowers/wk9-readme-generator',
		skill: 'Node | Inquirer | Object Destructuring',
		description:
			'The project was made using node.js in an effort to simplify README creation for GitHub projects going forward. The generator provides a foundation for README creation that is flexible enough to fit differing project goals. The generator creates a firm foundation from which to build a variety of project README files with a dynamic table of contents depending on developer`s focus. [note: video demonstration available on github]',
		date: 'SEP 2021',
		image: Readme,
	},
	{
		id: 6,
		project_name: 'Stick It to Starbucks',
		live_link:
			'https://brigittepowers.github.io/stick-it-to-starbucks-project-1/',
		repo_link:
			'https://github.com/BrigittePowers/stick-it-to-starbucks-project-1',
		skill: 'HTML | CSS | JS | BULMA.io | Google API | Responsive UI',
		description:
			'The goal of this project was to develop an application that will provide results about nearby local coffee shops in a given radius from the user’s location. Upon result selection, app will provide navigational assistance to that location as an alternative to Starbucks in an effort to support the local community.',
		date: 'SEP 2021',
		image: Sits,
	},
	{
		id: 5,
		project_name: 'Calming Colors Weather App',
		live_link: 'https://brigittepowers.github.io/wk6-weather-app/',
		repo_link: 'https://github.com/BrigittePowers/wk6-weather-app',
		skill: 'HTML | CSS | JS | Mobile-First Design | Local Storage | Third-Party API',
		description:
			'The goal of this project was to create a working weather application that can pull weather data from the openweather API',
		date: 'SEP 2021',
		image: Weather,
	},
	{
		id: 4,
		project_name: 'Day Planner',
		live_link: 'https://brigittepowers.github.io/wk5-3p-api-day-planner/',
		repo_link: 'https://github.com/BrigittePowers/wk5-3p-api-day-planner',
		skill: 'JS | JQuery | Third Party API | Moment.js | Bootstrap | Local Storage',
		description:
			'The goal of this project was to create a daily planner utilizing jquery, moment.js, boostrap and other third party APIs. The planner tracks time using moment.js and updates the input field colors accordingly to allow the user to track the day. The user can save tasks in assigned hourly text fields and have that data pull back up from local storage upon page reload.',
		date: 'AUG 2021',
		image: Planner,
	},
	{
		id: 3,
		project_name: 'Coding Quiz',
		live_link: 'https://brigittepowers.github.io/wk4-webapi-code-quiz/',
		repo_link: 'https://github.com/BrigittePowers/wk4-webapi-code-quiz',
		skill: 'JS | Dynamic | Local Storage | Timed Events',
		description:
			'The purpose of this project was to create a functional quiz page with dynamic elements while keeping it friendly for mobile and tablet users. The quiz opens with a landing page then clears the contents in order to dynamic generate quiz questions/answers pulled from an array of objects. Scores are calculated at the end of each quiz attempt and are available for local storage to be viewed under Highscores.',
		date: 'AUG 2021',
		image: Quiz,
	},
	{
		id: 2,
		project_name: 'Password Generator',
		live_link: 'https://brigittepowers.github.io/bpowers-hw3-password-gen/',
		repo_link: 'https://github.com/BrigittePowers/wk3-password-gen',
		skill: 'HTML | JS',
		description:
			'The purpose of this project was to create a password generator that is able to take user-selected criteria and output a randomized password containing all requirements. The code is designed to first accept user criteria that needs to be in the password. It then generates a password and runs it through a validation function to make sure the randomized password fits all user-expected criteria. The code is also optimized for instances where the user might try to generate a password with no criteria selected or criteria outside of accepted parameters. In these instances, the interface will inform the user of any missing criteria.',
		date: 'AUG 2021',
		image: Password,
	},
	{
		id: 1,
		project_name: 'Glowing Cheatsheet',
		live_link:
			'https://brigittepowers.github.io/wk2-project-css-cheatsheet/',
		repo_link:
			'https://github.com/BrigittePowers/wk2-project-css-cheatsheet',
		skill: 'HTML | CSS',
		description:
			'A webpage that holds a collection of useful CSS boilerplate as well as demonstrating the boilerplate on the site itself.',
		date: 'AUG 2021',
		image: Snippet,
	},
];

export default Data;
